import { Box, Typography } from "@mui/material";
import React, { useContext } from "react";
import ShopCalendar from "../../admin/ShopSchedule/ShopCalendar/ShopCalendar";
import usePageName from "../../../hocs/usePageName";

const SchedulePage = () => {
  usePageName({
    heading: "Schedule",
    caption: null,
  });

  return (
    <Box>
      <ShopCalendar />
    </Box>
  );
};

export default SchedulePage;
